import { PrincipalSynergyTeamVO } from './PrincipalSynergyTeamVO';
/**
 * @KotlinClass com.sucsoft.organization.basic.management.commons.vo.PrincipalInfoVO
 */
export class PrincipalInfoVO {
    /**
     * @NomosDefineDescription "地址"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    address?: string;
    /**
     * @NomosDefineDescription "超级管理员账号"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    administratorAccount?: string;
    /**
     * @NomosDefineDescription "超级管理员密码"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    administratorPassword?: string;
    /**
     * @NomosDefineDescription "创建人"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    createPerson?: string;
    /**
     * @NomosDefineDescription "创建时间"
     * @NomosDefineType {"family":"Date","pattern":"YYYY-MM-dd"}
     * @NomosGenericElements []
     * @NomosDefineDate
     */
    createTime?: string;
    /**
     * @NomosDefineDescription "用户默认密码"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    defaultPwd?: string;
    /**
     * @NomosDefineDescription "成立日期"
     * @NomosDefineType {"family":"Date","pattern":"YYYY-MM-dd"}
     * @NomosGenericElements []
     * @NomosDefineDate
     */
    establishmentDate?: string;
    /**
     * @NomosDefineDescription "机构属性"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    govInstitutions?: string;
    /**
     * @NomosDefineDescription "邮编"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    govPostcode?: string;
    /**
     * @NomosDefineDescription "政府电话"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    govTelephone?: string;
    /**
     * @NomosDefineDescription ""
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    id!: string;
    /**
     * @NomosDefineDescription "法人"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    juridicalPerson?: string;
    /**
     * @NomosDefineDescription "主营业务"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    mainBusiness?: string;
    /**
     * @NomosDefineDescription "主体名称"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    principalName!: string;
    /**
     * @NomosDefineDescription "协同团队名称VO对象"
     * @NomosDefineType {"family":"array","elementType":{"family":"object","className":"com.sucsoft.organization.basic.management.commons.vo.PrincipalSynergyTeamVO","elementTypes":[]}}
     * @NomosGenericElements []
     */
    principalSynergyTeams?: Array<PrincipalSynergyTeamVO>;
    /**
     * @NomosDefineDescription "主体类型(production生产经营主体/government政府)"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    principalType!: string;
    /**
     * @NomosDefineDescription "协同主体ids"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    synergyPrincipalIds?: string;
    /**
     * @NomosDefineDescription "协同主体名称"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    synergyPrincipalNames?: string;
    /**
     * @NomosDefineDescription "协同团队名称"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    synergyTeamNames?: string;
    /**
     * @NomosDefineDescription "用户uid"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    uid?: string;
    /**
     * @NomosDefineDescription "统一社会信用代码"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    unifiedSocialCreditCode?: string;
    /**
     * @NomosDefineDescription "修改人"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    updatePerson?: string;
    /**
     * @NomosDefineDescription "修改时间"
     * @NomosDefineType {"family":"Date","pattern":"YYYY-MM-dd"}
     * @NomosGenericElements []
     * @NomosDefineDate
     */
    updateTime?: string;
}
